import React from "react";
import { motion } from "framer-motion";
import colors from "../styles/colors";
import { SlArrowDown } from "react-icons/sl";

interface ProductMainProps {
  image: string;
  title: string;
  description: string;
}

const ProductMain: React.FC<ProductMainProps> = ({
  image,
  title,
  description,
}) => {
  const scrollDown = () => {
    window.scrollBy({ top: 800, left: 0, behavior: "smooth" });
  };

  return (
    <div
      className="relative w-screen h-[75vh] md:h-screen font-serif overflow-hidden"
      style={{ backgroundColor: colors.black }}
    >
      <motion.img
        src={image}
        alt="Main Window Image for carpentry products"
        loading="lazy"
        className="absolute inset-0 w-full h-full object-cover" // object-cover helyett object-contain, hogy a kép ne legyen levágva
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
      />

      <div className="absolute flex flex-col h-full w-full items-center justify-center bg-black bg-opacity-40 p-8 sm:p-12 md:p-16">
        <motion.h1
          className="text-3xl sm:text-5xl md:text-7xl font-thin z-10 text-center mt-32"
          style={{color: colors.lightCream}} 
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.4 }}
        >
          {title}
        </motion.h1>
        <motion.p
          className="text-base sm:text-lg md:text-2xl mt-4 sm:mt-6 md:mt-8 text-center z-10"
          style={{color: colors.lightCream}} 
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{
            duration: 1,
            delay: 0.8,
            type: "spring",
            stiffness: 100,
          }}
        >
          {description}
        </motion.p>

        {/* Scroll down icon */}
        <motion.div
          className="absolute bottom-6 sm:bottom-8 md:bottom-12 left-1/2 transform -translate-x-1/2"
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 1.5, duration: 1 }}
        >
          <SlArrowDown
            className="text-3xl sm:text-4xl md:text-5xl text-white animate-bounce hover:text-gray-300 cursor-pointer"
            onClick={scrollDown}
          />
        </motion.div>
      </div>
    </div>
  );
};

export default ProductMain;
